import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Lock } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { apiErr } from "@/lib/api";
import { Logo } from "@/components/site/Header";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await login(email, password);
      toast.success("Welcome back!");
      navigate("/admin");
    } catch (err) {
      const msg = apiErr(err.response?.data?.detail) || "Login failed";
      setError(msg);
      toast.error(msg);
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-navy flex items-center justify-center px-6 relative overflow-hidden">
      <div className="absolute inset-0 grain-band opacity-30" />
      <div className="relative w-full max-w-md">
        <div className="flex justify-center mb-8"><Logo light /></div>
        <div className="bg-white rounded-2xl p-8 shadow-2xl">
          <div className="flex items-center gap-3 mb-6">
            <span className="h-11 w-11 rounded-xl bg-emerald-brand/10 text-emerald-brand flex items-center justify-center"><Lock size={20} /></span>
            <div><h1 className="font-display font-semibold text-xl text-navy">Admin Login</h1><p className="text-sm text-slate-500">Sign in to manage your site</p></div>
          </div>
          <form onSubmit={submit} data-testid="admin-login-form" className="space-y-5">
            <div><Label>Email</Label><Input required type="email" data-testid="login-email" className="mt-1.5 focus-visible:ring-emerald-brand" value={email} onChange={(e) => setEmail(e.target.value)} /></div>
            <div><Label>Password</Label><Input required type="password" data-testid="login-password" className="mt-1.5 focus-visible:ring-emerald-brand" value={password} onChange={(e) => setPassword(e.target.value)} /></div>
            <div className="-mt-2 text-right"><button type="button" onClick={() => navigate("/admin/forgot-password")} data-testid="forgot-password-link" className="text-sm text-emerald-brand hover:underline">Forgot password?</button></div>
            {error && <p data-testid="login-error" className="text-sm text-red-600 bg-red-50 border border-red-200 rounded-lg px-3 py-2">{error}</p>}
            <Button type="submit" disabled={loading} data-testid="login-submit" className="w-full bg-emerald-brand hover:bg-emerald-dark rounded-full py-6 font-semibold">{loading ? "Signing in…" : "Sign In"}</Button>
          </form>
        </div>
      </div>
    </div>
  );
}
